module.exports = __webpack_public_path__ + "static/media/4.ddf6ea1e.jpg";